import { useContext } from "react";
import { LanguageContext } from "@eriksdigital/atomic-ui/components";

export const useBasenamePath = (): string => {
  const { language } = useContext<any>(LanguageContext);
  return `/${language}/motor-calculator`;
};
